export default function PlatinumIcon({ className = "w-5 h-5", title = "Platinum" }) {
  return (
    <img
      src="/Platinum64.webp"
      alt={title}
      title={title}
      className={className}
      style={{ display: "inline-block" }}
    />
  );
}